import { UserState } from './UserState';

export enum BannerStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum BannerTypeEnum {
  BANNER = 'BANNER',
  POPUP = 'POPUP'
}

export enum BannerLocationActivationEnum {
  HOME_PAGE = 'HOME_PAGE',
  FIRE_INSURANCE_NEW_BUDGET = 'FIRE_INSURANCE_NEW_BUDGET',
  FIRE_INSURANCE_BUDGET_LIST = 'FIRE_INSURANCE_BUDGET_LIST',
  FIRE_INSURANCE_POLICY_LIST = 'FIRE_INSURANCE_POLICY_LIST',
  BOND_INSURANCE_NEW_ANALISYS = 'BOND_INSURANCE_NEW_ANALISYS',
  BOND_INSURANCE_ANALISYS_LIST = 'BOND_INSURANCE_ANALISYS_LIST',
  BOND_INSURANCE_PROPOSAL_LIST = 'BOND_INSURANCE_PROPOSAL_LIST',
  BOND_INSURANCE_POLICY_LIST = 'BOND_INSURANCE_POLICY_LIST',
  CAPIITALIZATION_LIST = 'CAPIITALIZATION_LIST',
  CLAIM_LIST = 'CLAIM_LIST'
}

export interface Banner {
  id?: string;

  banner?: any;

  createdBy?: UserState | string;

  updatedBy?: UserState | string;

  title: string;

  observations?: string;

  imageUrl?: string;

  redirectUrl?: string;

  status: BannerStatusEnum;

  newTab: boolean;

  createdAt?: Date;

  updatedAt?: Date;

  type?: BannerTypeEnum | string;

  campaignStartDate?: Date | string | null;

  campaignEndDate?: Date | string | null;

  activationLocation?: BannerLocationActivationEnum | string;
}
